import { TextField } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// MRT's built-in `filterVariant: "date"` renders a date picker built on
// @mui/x-date-pickers v6's API. This app is on v5 (the `renderInput`
// prop API), so opening that filter throws "renderInput is not a
// function" and crashes the page. Spread this into a column def INSTEAD
// of `filterVariant: "date"` to get a real, working datepicker filter
// built on this app's own v5-compatible MobileDatePicker.
export const dateColumnFilterProps = () => ({
  filterFn: (row, columnId, filterValue) => {
    if (!filterValue) return true;
    const rowDate = row.getValue(columnId);
    return !!rowDate && dayjs(rowDate).format("YYYY-MM-DD") === filterValue;
  },
  Filter: ({ column }) => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDatePicker
        value={column.getFilterValue() ? dayjs(column.getFilterValue()) : null}
        onChange={(date) =>
          column.setFilterValue(date ? date.format("YYYY-MM-DD") : undefined)
        }
        inputFormat="DD-MM-YYYY"
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            size="small"
            fullWidth
            placeholder="Filter date"
          />
        )}
      />
    </LocalizationProvider>
  ),
});
